import { SingleTopTaskInnerProps } from "@ads-core/types";

type StatusVariant<T> = {
  status: T | string;
  label: string;
  text: string;
  topTasks?: SingleTopTaskInnerProps[];
};

type PhaseMapperProps<T> = {
  currentStatus: T | string;
  variants: StatusVariant<T>[];
  fallback?: StatusVariant<T>;
};

export const statusMapper = <T,>(props: PhaseMapperProps<T>) => {
  const { currentStatus, variants } = props;
  const status = variants.find((variant) => variant.status === currentStatus);

  if (status) {
    return {
      label: status?.label,
      text: status?.text,
      topTasks: status?.topTasks ?? [],
    };
  }

  return props?.fallback;
};